import {HTTP} from '@/services/HttpServices';
import {
    ProductsServicesOrderDetails,
    ShoppingCartData,
    AuditLog
} from '@/products-and-services/ProductsServicesModels';
import {
    CartFollowUp,
    Order
} from '@/views/productsAndServices/shoppingCarts/shoppingCartModel';
import {FilterData} from '@/components/filter/FilterModel';
import {CancelToken} from 'axios';
import { Term } from '@/views/productsAndServices/terms/TermsModel';

const ROOT_URL = '/admin/customer-cart';
const ROOT_TERM_URL = '/public/terms';

export async function getCarts(searchTerm: string, filterData: FilterData, cancelToken: CancelToken): Promise<Order[]> {
    return await HTTP.post(`${ROOT_URL}?searchTerm=${searchTerm}`, filterData, { cancelToken });
}

export async function getCartById(cartNumber: string): Promise<ShoppingCartData> {
    return await HTTP.get(`${ROOT_URL}/${cartNumber}`);
}

export function cartData(orderDetails: ProductsServicesOrderDetails, cartNumber: string): Promise<ShoppingCartData> {
    return HTTP.post(`${ROOT_URL}/${cartNumber || ''}`, orderDetails);
}

export function createServiceOrder(cartId: string): Promise<string> {
    return HTTP.post(`${ROOT_URL}/${cartId}/service-order`).then(response => response.ivueServiceOrderId);
}

export function resendDocusignDocument(cartId: string): Promise<void> {
    return HTTP.put(`${ROOT_URL}/${cartId}/terms-and-conditions-docusign`, {});
}

export function getCartFollowup(cartId: string): Promise<CartFollowUp> {
    return HTTP.get(`${ROOT_URL}/${cartId}/follow-up`);
}

export function getTermsAndConditionsDocument(cartId: string): Promise<any> {
    return HTTP.getExpectingBlob(`${ROOT_URL}/${cartId}/terms-and-conditions`);
}

export function getCartAudit(cartId: string): Promise<AuditLog[]> {
    return HTTP.get(`${ROOT_URL}/${cartId}/audits`);
}

export function getTerm(id: string): Promise<Term> {
    return HTTP.get(`${ROOT_TERM_URL}/${id}`);
}


export async function updateCartFollowup(cartId: string, data: CartFollowUp): Promise<string> {
    const toSend = {
        followUpCancelled: data.followUpCancelled,
        followUpCompleted: data.followUpCompleted,
        followUpNotes: data.followUpNotes || ''
    };
    const {followUpId} = await HTTP.put(`${ROOT_URL}/${cartId}/follow-up/${data.followUpId || ''}`, toSend);
    return followUpId;
}
